import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminSubscriptionOrderType } from '../../enums/admin-subscription-order-type';
import { AdminSubscriptionOrderTypePipe } from '../../pipes/admin-subscription-order-type.pipe';

@Component({
  selector: 'app-admin-subscription-order-type',
  imports: [CommonModule, AdminSubscriptionOrderTypePipe],
  templateUrl: './admin-subscription-order-type.component.html',
  styleUrl: './admin-subscription-order-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminSubscriptionOrderTypeComponent {
  public readonly type = input.required<AdminSubscriptionOrderType>();

  protected readonly cssClass = computed(() => {
    switch (this.type()) {
      case AdminSubscriptionOrderType.Renewal:
        return 'text-blue-600';

      case AdminSubscriptionOrderType.First:
        return 'text-green-600';

      case AdminSubscriptionOrderType.Resubscribe:
        return 'text-indigo-600';

      default:
        return '';
    }
  });
}
